import { useEffect, useState } from 'react';

export const STREAM_PLAYER_UNLOCK_LS_KEY = 'vorakit_stream_player_unlocked';
const LOGO_CLICK_SESSION_KEY = 'vorakit_stream_player_logo_clicks';
export const STREAM_PLAYER_UNLOCK_EVENT = 'vorakit-stream-player-unlocked';

export function isStreamPlayerUnlocked() {
  try {
    return localStorage.getItem(STREAM_PLAYER_UNLOCK_LS_KEY) === '1';
  } catch {
    return false;
  }
}

function readClickCount() {
  try {
    const n = parseInt(sessionStorage.getItem(LOGO_CLICK_SESSION_KEY) || '0', 10);
    return Number.isFinite(n) ? Math.max(0, n) : 0;
  } catch {
    return 0;
  }
}

function writeClickCount(n) {
  try {
    sessionStorage.setItem(LOGO_CLICK_SESSION_KEY, String(n));
  } catch {
    /* ignore */
  }
}

function clearClickCount() {
  try {
    sessionStorage.removeItem(LOGO_CLICK_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function unlockStreamPlayer() {
  try {
    localStorage.setItem(STREAM_PLAYER_UNLOCK_LS_KEY, '1');
    clearClickCount();
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(STREAM_PLAYER_UNLOCK_EVENT));
}

/**
 * Call on the main navbar logo image only (not the wordmark).
 * After 7 clicks (same browser session), persists unlock and dispatches {@link STREAM_PLAYER_UNLOCK_EVENT}.
 * @returns {boolean} true if this click caused unlock
 */
export function recordMainLogoClickForStreamPlayer() {
  if (isStreamPlayerUnlocked()) return false;
  const next = readClickCount() + 1;
  writeClickCount(next);
  if (next >= 7) {
    unlockStreamPlayer();
    return true;
  }
  return false;
}

/** Re-read unlock flag when localStorage changes in another tab or after logo sequence. */
export function useStreamPlayerUnlocked() {
  const [unlocked, setUnlocked] = useState(() => isStreamPlayerUnlocked());

  useEffect(() => {
    const sync = () => setUnlocked(isStreamPlayerUnlocked());
    window.addEventListener(STREAM_PLAYER_UNLOCK_EVENT, sync);
    const onStorage = (e) => {
      if (e.key === STREAM_PLAYER_UNLOCK_LS_KEY || e.key === null) sync();
    };
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(STREAM_PLAYER_UNLOCK_EVENT, sync);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return unlocked;
}
